var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 173,
    viewBox: "0 0 231 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.875C0 7.23828 6.28906 0.5 14.375 0.5H64.6875C73.6719 0.5 81.7578 4.54297 87.1484 11.7305L136.113 72.375H172.5V50.8125C172.5 46.7695 174.746 42.7266 178.789 40.9297C182.832 39.582 187.773 40.4805 190.469 43.1758L226.406 79.1133C230.898 83.6055 230.898 90.3438 226.406 94.3867L190.469 130.324C187.773 133.469 182.832 134.367 178.789 133.02C174.746 131.223 172.5 127.18 172.5 122.688V101.125H136.113L87.1484 162.219C81.7578 169.406 73.6719 173 64.6875 173H14.375C6.28906 173 0 166.711 0 158.625C0 150.988 6.28906 144.25 14.375 144.25H64.6875L110.957 86.75L64.6875 29.25H14.375C6.28906 29.25 0 22.9609 0 14.875Z",
    fill: "#22365E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.70e547cb73918afcf92a109a24a1a195.svg";
export { ForwardRef as ReactComponent };